import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // PWAの古いキャッシュで環境変数が欠落している場合、リロードを試みる（1回のみ）
  const reloadKey = 'supabase_env_reload';
  if ('serviceWorker' in navigator && !sessionStorage.getItem(reloadKey)) {
    sessionStorage.setItem(reloadKey, '1');
    navigator.serviceWorker.getRegistrations().then(regs => {
      regs.forEach(r => r.unregister());
    });
    window.location.reload();
  }
  throw new Error('環境変数が設定されていません。ブラウザをリフレッシュしてください。');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    // Web Locks API がシークレットモードやBrave等で失敗する問題を回避
    // localStorage を明示的に指定し、デフォルトのIndexedDB+Locksに依存しない
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
});
